import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useChange } from "../stores/houseStore";

const ChangeDetail = () => {
    const navigate = useNavigate();
    const change = useChange();

    const [old_password, setOldPassword] = useState("");
    const [new_password, setNewPassword] = useState("");
    const [errors, setErrors] = useState({});
    const [success, setSuccess] = useState(false);

    const validate = () => {
        let newErrors = {};

        if (!old_password) {
            newErrors.old_password = "Введите старый пароль";
        } else if (old_password.length < 6) {
            newErrors.old_password = "Пароль должен быть не менее 6 символов";
        }

        if (!new_password) {
            newErrors.new_password = "Введите новый пароль";
        } else if (new_password.length < 6) {
            newErrors.new_password = "Пароль должен быть не менее 6 символов";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validate()) {
            return;
        }
        const success = await change({ old_password, new_password });
        if (success) {
            setSuccess(true);
            setTimeout(() => navigate("/detail/profile/"), 7000);
        }
    };


    const ErrorText = ({ name }) =>
        errors[name] ? (
            <p className="text-xs text-red-600 mt-1">{errors[name]}</p>
        ) : null;

    return (
        <div
            style={{
                backgroundImage: `url(https://avatars.mds.yandex.net/i?id=47f5594ae981e3ba08c56c87f234e612_l-10150420-images-thumbs&n=13)`,
            }}
            className="relative z-20 bg-cover flex items-center min-h-[75vh]"
        >
            <div className="md:w-2/5 mx-auto">
                <div className="flex items-center justify-center rounded-2xl bg-white/45 backdrop-blur-md relative overflow-hidden">
                    <div className="px-10 py-4 md:p-8 rounded-lg shadow-md w-full">
                        <h2 className="md:text-2xl text-xl font-semibold text-black/70 mb-2 md:mb-6">
                            Смена пароля
                        </h2>

                        <form onSubmit={handleSubmit} className="md:space-y-4 space-y-1">
                            <div>
                                <label className="text-black/70 block text-sm mb-1">
                                    Старый пароль
                                </label>
                                <input
                                    value={old_password}
                                    onChange={(e) => setOldPassword(e.target.value)}
                                    type="password"
                                    className="w-full border text-black/70 bg-white/30 rounded-md px-3 py-2 focus:outline-none focus:shadow-md"
                                />
                                <ErrorText name="old_password" />
                            </div>

                            <div>
                                <label className="text-black/70 block text-sm mb-1">
                                    Новый пароль
                                </label>
                                <input
                                    value={new_password}
                                    onChange={(e) => setNewPassword(e.target.value)}
                                    type="password"
                                    className="w-full border text-black/70 bg-white/30 rounded-md px-3 py-2 focus:outline-none focus:shadow-md"
                                />
                                <ErrorText name="new_password" />
                            </div>
                            {success && <p className="text-green-600 text-sm mt-2">Пароль успешно поменялся</p>}
                            <div className="flex flex-col items-center space-y-2">
                                <button
                                    type="submit"
                                    className="w-full bg-black/60 duration-300 text-white py-2 rounded-lg hover:bg-black transition"
                                >
                                    Сменить пароль
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ChangeDetail;
